export default __webpack_public_path__ + "static/samokat_product_1-05607b26b55f9840a4c122cd8025ce05.png";